/**
 * Screens that have to work without a session.
 *
 * Someone who has forgotten their password arrives from the e-mail link with
 * no valid token - that is the whole point - so anything that sends a visitor
 * to /login when a token is missing or expired has to make an exception here,
 * or the reset screen is gone before they can type anything.
 *
 * /change-password is deliberately NOT on this list: it is reached while
 * signed in, replacing a password that was issued to the user.
 */
export const PUBLIC_PATHS = ["login", "reset-password"];

export const isPublicPath = (pathname: string = window.location.pathname): boolean =>
	PUBLIC_PATHS.some(path => pathname.includes(path));
